import React from "react";
import TagsFilter from "cube-components/blog/TagsFilter";
import Seo from "cube-components/Seo";
import PageLayout from "cube-components/PageLayout";
import Heading from "cube-components/ui/Heading";

const TagsList = result => {
  const { pageContext } = result;
  const { tags } = pageContext;

  return (
    <PageLayout>
      <section className="relative border-t border-lucid-800">
        <div className="relative max-w-6xl mx-auto px-4 sm:px-6">
          <div className="pt-32 md:pt-40">
            <div className="max-w-3xl mx-auto text-left">
              <Heading title={`Tags of Lucid Modules Blog`}
                       subtitle={`Find our blog posts categorized by tags.`}
              />
              <TagsFilter tags={tags.sort()} />
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export const Head = () => {
  const meta = {
    title: "Tags | Lucid Modules",
    description: "Find tags about Magento 2 and Web related topics",
    robots: "noindex,follow"
  };

  return <Seo lang="en"
              meta={meta}
  />;
};

export default TagsList;
